// One game's numbers for both teams (/match-stats; the Match module, Ben 2026-10-31): the bars
// down the Match card, each team's number at its end. From the stats engine's own definitions, so
// they match the team Stats tiles.

/** The stats the card shows, in its order. */
export const MATCH_STAT_KEYS = [
  "xg",
  "shots",
  "shotsOnTarget",
  "touchesInBox",
  "corners",
  "aerialsWon",
  "saves",
  "fouls",
] as const;
export type MatchStatKey = (typeof MATCH_STAT_KEYS)[number];

/** One team in the game. A number is null when the engine has nothing stored for it. */
export interface MatchStatsTeam {
  teamId: number;
  teamName: string;
  /** Share of the game's possession, 0–100 (the two teams add up to 100); null if not stored. */
  possession: number | null;
  values: Record<MatchStatKey, number | null>;
}

export interface MatchStatsResponse {
  /** Both teams, or none when the game has no event data yet. */
  teams: MatchStatsTeam[];
}
